import React, { useState, useEffect } from 'react';
import { CSVImport } from './CSVImportFIle'
import { uploadSoaCsv,getBulkUploadCsvLogs,getSampleFile,getBankList } from '@src/store/slices/common';
import { toast } from 'react-toastify';
import secureStorage from "@src/config/encrypt";
import FullPageLoader from '@src/common/FullPageLoader';
import { useDispatch, useSelector } from 'react-redux'
import Select, { components } from 'react-select';
import { ReceivedDate } from "../../component/DatePicker";
import {CHEQUE_SLUG,RAGEX_NUMBER_UPTO_2_DECIMAL_PLACES,REGEX_ONLY_NUMBER} from '../../config/constant';
import { getAgencyList } from '../../../src/store/slices/common';



interface MRPBCAMFModalProps {
    setUpdateModal: any;
    type: any;
    mode_of_payment : any;
    closeBulkUploadModal: any;
}

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};


const BulkImportModal: React.FC<MRPBCAMFModalProps> = ({ setUpdateModal, type,mode_of_payment, closeBulkUploadModal }) => {
    const [csvValue, setCsvValue] = useState<any>(null);
    let [loading, setLoading] = useState<boolean>(false)
    let [emptyErr, setEmptyErr] = useState<boolean>(false)
    const [IssuingBank, setIssuingBank] = useState<any[]>([]);

    const [csvReset, setCsvReset] = useState(0);

    const [BlankFlage, setBlankFlage] = useState(0);
    const [urlLink, setUrlLink] = useState('');

    const dispatch: any = useDispatch()
    const [selectedFilters, setSelectedFilters] = useState<any>({application_type: 1});
    const errField = ({
        appType: ""
    });

    const [bulkLog, setBulkLog] = useState([]);

    const insuranceState = useSelector((state: any) => state.common)

    const [agents, setAgents] = useState<any>([]);
    const [isChequeSelected, setIsChequeSelected] = useState<boolean>(false);

    const [formData, setFormData] = useState<any>({});
    const [errorMsg, setErrorMesg] = useState<any>({});
    const [paymentProofUrl, setPaymentProofUrl] = useState<string>("");


    useEffect(() => {
        if (!insuranceState?.bankList?.length) {
            dispatch(getBankList()).then((res: any) => {
                if (res && res.status === 200) {
                    setIssuingBank((prev: any) => [...prev, ...res.data]);
                }
            })
        } else {
            setIssuingBank(insuranceState?.bankList);
        }
            // eslint-disable-next-line
        }, []);

    const getAgencyFilterData = () => {
        dispatch(getAgencyList()).then((res: any) => {
            if (res && res.status === 200) {        
            if (res.data) {
                const updatedAgents = res.data?.map((agent:any) => ({
                    ...agent,
                    label: `${agent.label} (ID: ${agent.value})`
                }));
                setAgents(updatedAgents);
            }
            }
        }).catch((err: Error) => {
        })
    }
    
    useEffect(() => {
        if (Object.keys(insuranceState.agencyList).length === 0) {
            getAgencyFilterData();
        }else{
            const updatedAgents = insuranceState.agencyList?.map((agent:any) => ({
                ...agent,
                label: `${agent.label} (ID: ${agent.value})`
            }));
            setAgents(updatedAgents);
        }
    },[])

    useEffect(() => {
        if (!formData.payment_proof) {
            setPaymentProofUrl("");
            return;
        }

        const fileUrl = URL.createObjectURL(formData.payment_proof);
        setPaymentProofUrl(fileUrl);

        return () => {
            URL.revokeObjectURL(fileUrl);
        };
    }, [formData.payment_proof])

    const handlePaymentProofChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        setFormData((prev:any) => ({
            ...prev,
            payment_proof: file,
        }));
        setErrorMesg((prev:any) => ({
            ...prev,
            payment_proof: ""
        }));
        event.target.value = "";
    };

    const handleRemovePaymentProof = () => {
        setFormData((prev:any) => {
            const updatedFormData = { ...prev };
            delete updatedFormData.payment_proof;
            return updatedFormData;
        });
        setErrorMesg((prev:any) => ({
            ...prev,
            payment_proof: ""
        }));
    };

    const validForm = () => {
        let formIsValid = true;
        let errors: any = {};
        // Mode of Payment (mandatory)
        if (!formData.mode_of_payment) {
            formIsValid = false;
            errors.mode_of_payment = "Mode of payment is required";
        }
        // Cheque-related validations (only if Post Dated Cheque selected)
        if (isChequeSelected) {
            if (!formData.cheque_no) {
                formIsValid = false;
                errors.cheque_no = "Cheque number is required";
            }

            if (!formData.cheque_issue_date) {
                formIsValid = false;
                errors.cheque_issue_date = "Cheque issue date is required";
            }

            if (!formData.cheque_due_date) {
                formIsValid = false;
                errors.cheque_due_date = "Cheque due date is required";
            }

            if (!formData.cheque_issuing_bank) {
                formIsValid = false;
                errors.cheque_issuing_bank = "Cheque issuing bank is required";
            }
        }
        if (!formData.total_amount_received) {
            formIsValid = false;
            errors.total_amount_received = "Total amount received is required";
        }
        // Agent ID (mandatory)
        if (!formData.agent_id) {
            formIsValid = false;
            errors.agent_id = "Agent ID is required";
        }
        // Amount Received Date (mandatory)
        if (!formData.amount_received_date) {
            formIsValid = false;
            errors.amount_received_date = "Amount received date is required";
        }
        if (!formData.payment_proof) {
            formIsValid = false;
            errors.payment_proof = "Upload Proof of Payment is required";
        }
        if (!csvValue) {
            formIsValid = false;
            setEmptyErr(true);
        }
        setErrorMesg(errors);
        return formIsValid;
    };


    const handleImport = () => {
        if (validForm()) {
            let result = secureStorage.getItem("authUserInfo");
            let userId = result && result.user_data && result.user_data.id

            setLoading(true);

            let payload = new FormData();
            payload.append("type", type);
            payload.append("images", csvValue);
            payload.append("user_id", userId);
            payload.append("application_type", selectedFilters.application_type);
            payload.append("mode_of_payment",formData.mode_of_payment);
            if(isChequeSelected){
                payload.append("cheque_no",formData.cheque_no);
                payload.append("cheque_issue_date",formData.cheque_issue_date);
                payload.append("cheque_due_date",formData.cheque_due_date);
                payload.append("cheque_issuing_bank",formData.cheque_issuing_bank);
            }
            payload.append("total_amount_received",formData.total_amount_received);
            payload.append("agent_id",formData.agent_id);
            payload.append("amount_received_date",formData.amount_received_date);
            payload.append("payment_proof", formData.payment_proof);

            
            uploadSoaCsv(payload).then((res: any) => {
                setLoading(false)
                // closeBulkUploadModal()
                if (res && res.status === 200) {
                    toast.success(res.message);
                    // setUpdateModal(false);
                    setCsvValue('');
                    setBlankFlage(BlankFlage + 1);
                    setLoading(false)
                    getBulkUploadCsvLogs().then((data: any) => {
                        setBulkLog(data?.data)
                        setFormData({});
                        setErrorMesg({});
                        setIsChequeSelected(false);
                        setLoading(false)
                    });

                } else {
                    setLoading(false);
                    setCsvValue('');
                    setFormData({});
                    setErrorMesg({});
                    setIsChequeSelected(false);
                    setBlankFlage(BlankFlage + 1);
                }

            }).catch(err => setLoading(false))


            setCsvReset(csvReset + 1);
        }
    };

    useEffect(() => {

        if(!insuranceState?.sampleCsv?.length) {
            dispatch(getSampleFile()).then((res: any) => {
                if (res && res.status === 200) {
                }
            }).catch((err: Error) => {
            })
        }

        setLoading(true)
        getBulkUploadCsvLogs().then((data: any) => {
            setBulkLog(data?.data)
            setLoading(false)

        });

        // eslint-disable-next-line
    }, [type]);



    // Handle changes in dropdown selections
    // const handleChange = (selectedOption: any, key: string) => {
    //     setSelectedFilters({ [key]: selectedOption['value'] })
    //     errField['appType'] = '';
    // }

    const downloadBulkUploadLeadLog = (logId: number) => {
        try{
            const findLog:any = bulkLog.find((data:any) => +data.id === +logId)
            if(findLog){
                let link = document.createElement("a");
                let urlLink = findLog.processed_s3_path;
                let urlName = urlLink?.split('?')?.[0];
                urlName = urlName?.split('/');
                link.download = urlName?.[urlName.length-1];
                link.href = urlLink;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }catch(error){
            console.log("error==>",error);
        }
    }

    useEffect(()=>{
        const match = insuranceState.sampleCsv.find((insurance: any) => insurance.slug === type);
            
        if (match) {
            setUrlLink(match.path);
        }
        // eslint-disable-next-line
    }, [insuranceState.sampleCsv])

    const handleFieldChange = (field: string, value: any) => {
        if(field === "mode_of_payment"){
            const isCheque = mode_of_payment.find((item:any) => +item.value === +value);
            if(isCheque.slug === CHEQUE_SLUG){
                setIsChequeSelected(true);
            }else{
                setIsChequeSelected(false);
            }
        }
        if(field === "cheque_no" && value !== "" && !REGEX_ONLY_NUMBER.test(value)){
            return
        }
        if (field === "total_amount_received" && value !== "" && !RAGEX_NUMBER_UPTO_2_DECIMAL_PLACES.test(value)) {
            return;
        }
        setFormData((prev:any) => ({
            ...prev,
            [field]:value,
        }))
    }

    return (

        <>
            <div className="bulk-upload-sec">
                <div className="calculator-form csv-table">
                    <FullPageLoader show={loading} />
                    <div className="row">
                        <div className="col-md-12">
                            <fieldset className="single-select">
                                <div className="material">
                                    <Select
                                        components={{ ValueContainer: CustomValueContainer }}
                                        options={mode_of_payment}
                                        placeholder="Mode Of payment*"
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        onChange={(option:any) => handleFieldChange("mode_of_payment", option?.value)}
                                        value={mode_of_payment.find((opt:any) => opt.value === formData.mode_of_payment) || null}
                                    />
                                
                                {errorMsg.mode_of_payment && <span className="error">{errorMsg.mode_of_payment}</span>}
                                </div>
                            </fieldset>
                            {
                                isChequeSelected &&
                                <>
                                    <fieldset>
                                        <div className="material">
                                            <input type="text" placeholder=" " name="chequeNo" className="form-input" value={formData.cheque_no || ""}
                                                onChange={(e) => handleFieldChange("cheque_no", e.target.value)}
                                            />
                                            <label data-label="Cheque No.*" className="form-label"></label>
                                            {errorMsg.cheque_no && <div className="error">{errorMsg.cheque_no}</div>}
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <div className="material">
                                            <ReceivedDate placeholder="Cheque Issue Date*" maxDate={new Date()} selectedDate={formData.cheque_issue_date ? new Date(formData.cheque_issue_date) : null}
                                            onDateChange={(date) => handleFieldChange("cheque_issue_date", date?.toISOString())}
                                            />
                                            {errorMsg.cheque_issue_date && <div className="error">{errorMsg.cheque_issue_date}</div>}
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <div className="material">
                                            <ReceivedDate placeholder="Cheque Due Date*" maxDate={new Date()} selectedDate={formData.cheque_due_date ? new Date(formData.cheque_due_date) : null}
                                            onDateChange={(date) => handleFieldChange("cheque_due_date", date?.toISOString())}
                                            />
                                            {errorMsg.cheque_due_date && <div className="error">{errorMsg.cheque_due_date}</div>}
                                        </div>
                                    </fieldset>
                                    <fieldset className="single-select">
                                        <div className="material">
                                            <Select
                                            components={{ ValueContainer: CustomValueContainer }}
                                            options={IssuingBank}
                                            placeholder="Cheque Issuing Bank *"
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            value={IssuingBank.find((b) => Number(b.value) === Number(formData.cheque_issuing_bank)) || null}
                                            onChange={(option:any) => handleFieldChange("cheque_issuing_bank", option?.value)}
                                            />
                                            {errorMsg.cheque_issuing_bank &&  <div className="error">{errorMsg.cheque_issuing_bank}</div>}
                                        </div>
                                    </fieldset>
                                </>
                            }
                            <fieldset>
                                <div className="material">
                                    <input type="text" placeholder=" " name="Total Amount Received*" className="form-input" value={formData.total_amount_received || ""}
                                       onChange={(e) => handleFieldChange("total_amount_received", e.target.value)}
                                    />
                                    <label data-label="Total Amount Received*" className="form-label"></label>
                                    {errorMsg.total_amount_received && <div className="error">{errorMsg.total_amount_received}</div>}
                                </div>
                            </fieldset>
                            <fieldset className="single-select">
                                <div className="material">
                                    <Select
                                        components={{ ValueContainer: CustomValueContainer }}
                                        options={agents}
                                        placeholder="Agent ID*"
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        onChange={(option:any) => handleFieldChange("agent_id", option?.value)}
                                        value={agents.find((b:any) => Number(b.value) === Number(formData.agent_id)) || null}
                                    />
                                
                                {errorMsg['agent_id'] &&  <span className="error">{errorMsg['agent_id']}</span>}
                                </div>
                            </fieldset>
                            <fieldset>
                                <div className="material">
                                    <ReceivedDate 
                                    placeholder="Amount Received Date*" 
                                    maxDate={new Date()}
                                    selectedDate={formData.amount_received_date ? new Date(formData.amount_received_date) : null}
                                    onDateChange={(date) => handleFieldChange("amount_received_date", date?.toISOString())}
                                    />
                                    {errorMsg.amount_received_date && <div className="error">{errorMsg.amount_received_date}</div>}
                                </div>
                            </fieldset>
                            <fieldset>
                                <div className="attech-repair-doc">
                                    <div className="upload-text">
                                        <i className="ic-attach_file"></i>
                                        <input type="file" name="payment_proof" onChange={handlePaymentProofChange} />
                                        <p>Upload Proof of Payment*</p>
                                    </div>
                                    {formData.payment_proof && (
                                        <div className="uploaded-file">
                                            <div className="upload-file-name">
                                                <a
                                                    href={paymentProofUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {formData.payment_proof.name}
                                                </a>
                                            </div>
                                            <span className="remove-icon" onClick={handleRemovePaymentProof}>✕</span>
                                        </div>
                                    )}
                                </div>
                                {errorMsg.payment_proof && <span className="error">{errorMsg.payment_proof}</span>}
                            </fieldset>
                        </div>
                        <div className="col-md-12">
                            <h3>Upload File</h3>
                                <CSVImport setCsvValue={setCsvValue} csvReset={csvReset} emptyErr={emptyErr} BlankFlage={BlankFlage} setError={setEmptyErr} fileType={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv', 'application/excel', 'application/x-excel', 'application/x-msexcel']} />
                            <div>
                            </div>
                            <div className="download-txt">
                                Download input format <a href={`${urlLink}`} download>Click Here</a>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <button className="btn-primary" onClick={handleImport}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bulk-history-sec">
                <h3>Upload History</h3>
                <div className="bulk-history-table">
                    <div className="data-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Date &amp; Time</th>
                                    <th>Who</th>
                                    <th>Records</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    bulkLog?.length>0 ?
                                    bulkLog?.map(( log:any, key:number)=>
                                    <tr key={key}>
                                        <td> {log.created_at }</td>
                                        <td><span className="truncate">{log.firstname} {log.lastname}</span></td>
                                        <td>
                                            <ul className="record-list-data">
                                                <li title='Success Count'>{log.success_count}</li>
                                                <li><p title='Error Count'>{log.failure_count}</p></li>
                                                <li title='Total Count'>{log.total_count}</li>
                                            </ul>
                                        </td>
                                        <td><span className="truncate">{((+log.success_count + +log.failure_count) === +log.total_count)? "Completed": "In Progress"}</span></td>
                                        <td>
                                            <ul className="action-btn">
                                                <li onClick={()=>downloadBulkUploadLeadLog(log.id)}><i className="ic-save_alt"></i></li>
                                            </ul>
                                        </td>
                                    </tr>)
                                    :
                                    <tr><td className='t-center' colSpan={5}>No Logs Found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>

    )
}
export default BulkImportModal;